import { HttpParams } from '@angular/common/http';
import { PlacewiseHttpParamsCodec } from './placewise-http-params-codec';

export interface ToHttpParamsOptions {
  /**
   * Whether to leave nulls in params.
   */
  leaveNulls?: boolean;
}

/**
 * Parses given object and returns HttpParams from it.
 * Currently supports arrays but not nested objects.
 * Uses PlacewiseHttpEncoder as HttpParams.encoder.
 * @param object object to parse into HttpParams
 * @param options additional options to pass
 */
export function toHttpParams(object: any, options: ToHttpParamsOptions = {}): HttpParams {
  const { leaveNulls } = options;

  let params = new HttpParams({ encoder: new PlacewiseHttpParamsCodec() });
  if (!object) { return params; }

  Object.entries(object).forEach(([k, v]) => {
    if (!leaveNulls && v == null) { return; }

    if (Array.isArray(v)) {
      v.forEach((element) => params = params.append(`${k}[]`, element.toString()));
    } else {
      params = params.append(k, v?.toString() || '');
    }
  });

  return params;
}
